import React, { useState } from "react";
import PropTypes, { number } from "prop-types";
import _ from "lodash";
import ahoy from "ahoy.js";
import PrecacheImg from "../../../../utils/PrecacheImage";
import Modal from "../../../../utils/Modal";
import LightBox from "./LightBox";
import LightBoxPrintProducts from "./LightBoxPrintProducts";
import Gallery from "react-grid-gallery";
import millisecondsTohms from "../../../../utils/millisecondsTohms";
import Telemetry from "../../../../utils/rudderstackAnalytics";
const gssNewLoader = require("../../../../assets/gss-loader.gif");
const playIcon = require("../../styles/play.svg");
const hiddenIcon = require("../../styles/imgHide.svg");
import { Album as AlbumType, Event } from "../types";
import { CartOutline, CartFilled } from "../vectors/AddToCartIcon";
import { CheckOutline, CheckFilled } from "../vectors/CheckIcon";

interface ImageComponentProps {
  props: {
    item: {
      videoContent: any;
      videoDuration: string | number;
      thumbnail: string | undefined;
      id: number;
      album: { name: string };
      hidden: boolean;
      isSelected: boolean;
      digitalDownloadDisabled?: boolean;
    };
    imageProps: React.ImgHTMLAttributes<HTMLImageElement>;
    index: number;
  };
  handleImageSelect: ({ photo, index }: { photo: any; index: number }) => void;
  canAddToDownloadList: boolean;
  handleDownloadImageSelection: ({
    photo,
    index
  }: {
    photo: any;
    index: number;
  }) => void;
  primaryColor: string;
  shouldShowCheckIcon: boolean;
  hideSelectIcon: boolean;
  event: {
    id: number;
    name: string;
    price: number;
    hasPrintProducts?: boolean;
  };
  addPhotoToCart: (photo: any) => void;
  removePhotoFromCart: (photo: any) => void;
  printProductsflow: () => boolean;
}

const ImageComponent = ({
  props,
  handleImageSelect,
  handleDownloadImageSelection,
  canAddToDownloadList,
  primaryColor,
  shouldShowCheckIcon,
  hideSelectIcon,
  event,
  addPhotoToCart,
  removePhotoFromCart,
  printProductsflow
}: ImageComponentProps) => {
  const [show, setShow] = useState(false);

  const handleHideTooltip = () => {
    //@ts-ignore
    $(`[data-toggle="tooltip"]#cart-tooltip-${props.item.id}`).tooltip("hide");
  };

  const handleTooltip = () => {
    if (
      printProductsflow() &&
      props.item.isSelected &&
      !shouldShowCheckIcon
    ) {
      const $el = $(`[data-toggle="tooltip"]#cart-tooltip-${props.item.id}`);
      // @ts-ignore
      $el
        .tooltip()
        .attr("data-original-title", "Products of this photo are in cart")
        .tooltip("show");
    }
  };

  const ImageSelectIcon = hideSelectIcon ? null : (
    <div
      id={`cart-tooltip-${props.item.id}`}
      className="geo-cart-icon-container"
      data-toggle="tooltip"
      data-placement="top"
      data-container="body"
      onClick={e => {
        e.stopPropagation();
        if (shouldShowCheckIcon) {
          canAddToDownloadList
            ? handleDownloadImageSelection({
                photo: props.item,
                index: props.index
              })
            : handleImageSelect({ photo: props.item, index: props.index });
        } else if (!printProductsflow() && !props.item.digitalDownloadDisabled) {
          // Handle cart functionality only for non-print products events
          if (props.item.isSelected) {
            removePhotoFromCart(props.item);
          } else {
            addPhotoToCart(props.item);
          }
        }
      }}
      onMouseEnter={() => handleTooltip()}
      onMouseLeave={() => handleHideTooltip()}
      style={{
        cursor:
          shouldShowCheckIcon ||
          (!printProductsflow() && !props.item.digitalDownloadDisabled)
            ? "pointer"
            : "default"
      }}
    >
      {shouldShowCheckIcon ? (
        props.item.isSelected ? (
          <CheckFilled color={primaryColor || "#34b2a7"} />
        ) : (
          <CheckOutline />
        )
      ) : props.item.isSelected ? (
        <CartFilled
          color={
            printProductsflow() ? "#0000008f" : primaryColor || "#34b2a7"
          }
        />
      ) : !printProductsflow() && !props.item.digitalDownloadDisabled ? (
        <CartOutline />
      ) : null}
    </div>
  );

  if (props.item.videoContent) {
    return (
      <div style={{ textAlign: "center", cursor: "pointer" }}>
        {props.item.hidden && (
          <span className="visibility-stamp">
            <img src={hiddenIcon} alt="" />
          </span>
        )}
        {ImageSelectIcon}
        <span className="time-stamp">
          {millisecondsTohms(props.item.videoDuration)}
        </span>
        <img className="play-icon" src={playIcon} alt="" />
        <img
          height="120px"
          src={props.item.thumbnail}
          onMouseEnter={() => setShow(true)}
          onMouseLeave={() => setShow(false)}
          alt={`${props.item.album.name}-${props.item.id}`}
        />
      </div>
    );
  } else
    return (
      <div style={{ textAlign: "center", cursor: "pointer" }}>
        {props.item.hidden && (
          <span className="visibility-stamp">
            <img src={hiddenIcon} alt="" />
          </span>
        )}
        {ImageSelectIcon}
        <img
          {...props.imageProps}
          alt={`${props.item.album.name}-${props.item.id}`}
        />
      </div>
    );
};

interface PhotosProps {
  event: Event;
  album: AlbumType;
  photos: any;
  cart?: {
    photos: any;
    id: number;
  };
  addPhotoToCart: (photo: any) => void;
  removePhotoFromCart: (photo: any) => void;
  loadMorePhotos: Function;
  updateAlbum: Function;
  loadingPhotos: boolean;
  expanded: boolean;
  collapsibleGallery: boolean;
  galleryRowsRendered: Function;
  listOfMediaId: Array<{ id: number; hidden: boolean }>;
  curationMode: boolean;
  userId: number;
  userSignedIn: boolean;
  guestUserId: null | number;
  filteredResult: boolean;
  updateCartFromApiResponse?: (apiResponse: any) => void;
  setSelfieUploadPopup?: (value: boolean) => void;
}

interface PhotosState {
  photos: any;
  showLightBox: boolean;
  photoIndex: number;
  reload: boolean;
  curationApiCalled: boolean;
  favorites: number[];
  selectedPhoto: { id: number | null; isFavorite: boolean; source: string };
  shouldShowDownload: boolean;
  canAddToDownloadList: boolean;
}

class Photos extends React.Component<PhotosProps, PhotosState> {
  constructor(props: PhotosProps) {
    super(props);

    this.state = {
      photos: [],
      showLightBox: false,
      photoIndex: -1,
      reload: false,
      curationApiCalled: false,
      favorites: [],
      selectedPhoto: { id: null, isFavorite: false, source: "" },
      shouldShowDownload: false,
      canAddToDownloadList: false
    };
  }

  static contextTypes = {
    curationMode: PropTypes.bool,
    loadAlbumPhotos: PropTypes.func,
    canManageTags: PropTypes.bool,
    eventCoverPickerMode: PropTypes.bool,
    selectCoverPhoto: PropTypes.func,
    getPhotoId: PropTypes.func,
    setPhotos: PropTypes.func,
    visiblePhotos: PropTypes.array,
    pageConfiguration: PropTypes.shape({
      primaryColor: PropTypes.string,
      secondaryColor: PropTypes.string,
      accentColor: PropTypes.string
    }),
    isEmbed: PropTypes.bool,
    userId: PropTypes.number,
    guestUserId: PropTypes.number,
    securedGalleryView: PropTypes.bool,
    directDownloadEnabled: PropTypes.bool,
    endUserDownloadsDisabled: PropTypes.bool,
    canShowEmailPopup: PropTypes.func
  };

  buildPhotosForGallery = (photos: any[], isSelected: Function) => {
    this.setState(
      {
        photos: photos.map(photo => {
          return {
            ...photo,
            ...(photo.timeTaken
              ? {
                  tags: [
                    {
                      title: "Time",
                      value: photo.timeTaken
                    }
                  ]
                }
              : {}),
            isSelected: isSelected(photo),
            src: "",
            hidden: photo.hidden,
            disableContextMenu: true,
            isFavorite: photo.favorite
          };
        })
      },
      () => {
        this.context.canManageTags &&
          this.context.setPhotos(
            _.uniqBy(
              [...this.state.photos, ...this.context.visiblePhotos],
              "id"
            )
          );
      }
    );
  };

  componentDidMount() {
    this.setState({
      shouldShowDownload:
        this.props.event.price === 0 && this.context?.directDownloadEnabled,
      canAddToDownloadList:
        !this.props.curationMode &&
        this.props.event.price === 0 &&
        this.context.directDownloadEnabled
    });
    if (this.props.filteredResult) {
      this.buildPhotosForGallery(this.props.photos, (photo: { id: any }) => {
        if (this.context.eventCoverPickerMode) {
          return photo.id === this.props.event.coverPhotoId;
        } else {
          const photoIds =
            (this.context.canManageTags && this.props.curationMode) ||
            this.state.shouldShowDownload
              ? this.props.listOfMediaId.map(item => item.id)
              : this.props.cart?.photos || [];

          return _.includes(photoIds, photo.id);
        }
      });
    }
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    if (
      // Photos changed
      this.props.photos !== prevProps.photos ||
      this.props.photos.length !== prevProps.photos.length ||
      // Loading state changed
      this.props.loadingPhotos !== prevProps.loadingPhotos ||
      // Lightbox state changed
      this.state.showLightBox !== prevState.showLightBox ||
      this.state.photoIndex !== prevState.photoIndex ||
      // Cart state changed
      (this.props.cart != null && prevProps.cart == null) ||
      (!this.props.cart && prevProps.cart) ||
      this.props.cart?.photos?.length !== prevProps.cart?.photos?.length ||
      // Gallery display settings changed
      this.props.collapsibleGallery !== prevProps.collapsibleGallery ||
      this.props.expanded !== prevProps.expanded ||
      // Cover photo changed
      this.props.event.coverPhotoId !== prevProps.event.coverPhotoId ||
      // Curation-related changes
      (this.context.canManageTags &&
        (this.props.listOfMediaId.length !== prevProps.listOfMediaId.length ||
          this.props.curationMode !== prevProps.curationMode))
    ) {
      // Build gallery with same logic as before
      this.buildPhotosForGallery(this.props.photos, (photo: { id: any }) => {
        if (this.context.eventCoverPickerMode) {
          return photo.id === this.props.event.coverPhotoId;
        } else {
          const photoIds =
            (this.context.canManageTags && this.props.curationMode) ||
            this.state.shouldShowDownload
              ? this.props.listOfMediaId.map((item: { id: any }) => item.id)
              : this.props.cart?.photos || [];

          return _.includes(photoIds, photo.id);
        }
      });

      // Hide lightbox when photos change and there's a filtered result
      if (this.props.photos !== prevProps.photos && this.props.filteredResult) {
        this.setState({ showLightBox: false });
      }
    }

    // Hide lightbox when guest user ID changes
    if (this.props.guestUserId !== prevProps.guestUserId) {
      this.setState({
        showLightBox: false
      });
    }
  }

  showLightBox = (index: number) => {
    if (index == -1) {
      this.setState({ showLightBox: false });
      return;
    }

    this.setState({ showLightBox: false }, () => {
      this.setState({
        showLightBox: true,
        photoIndex: index
      });
    });
    ahoy.track("photoView", {
      photo_id: this.state.photos[index].id,
      album_id: this.props.album.id,
      event_id: this.props.event.id
    });

    if (this.state.photos[index + 1] == undefined) {
      this.props.loadMorePhotos();
    }
  };

  closeLightBox = () => {
    this.setState({
      showLightBox: false
    });
  };

  imagesToPrefetch = () => {
    if (this.props.photos.length > 0) {
      return [
        this.props.photos[0].watermarkedImg,
        this.props.photos[0].zoomImg
      ];
    } else {
      return [];
    }
  };

  contextMenu = (e: any) => {
    e.preventDefault();
    return false;
  };

  toggleEventCoverSelection = (photo: any) => {
    if (photo.isSelected) {
      this.context.selectCoverPhoto(null);
    } else this.context.selectCoverPhoto(photo.id);
  };

  updatePhotoInCart = (photo: any) => {
    if (photo.isSelected) {
      this.props.removePhotoFromCart(photo);
      Telemetry.track("event-gallery:remove-from-cart", {
        eventId: this.props.event.id,
        eventName: this.props.event.name,
        photoId: photo.id,
        cartId: this.context.cartId,
        source: "thumbnail",
        embeddedMode: this.context.isEmbed
      });
    } else {
      this.props.addPhotoToCart(photo);
      Telemetry.track("event-gallery:add-to-cart", {
        eventId: this.props.event.id,
        eventName: this.props.event.name,
        photoId: photo.id,
        cartId: this.props.cart?.id,
        source: "thumbnail",
        embeddedMode: this.context.isEmbed
      });
    }
  };

  handleImageSelect = ({ photo, index }: { photo: any; index: number }) => {
    if (this.context.eventCoverPickerMode) {
      this.toggleEventCoverSelection(photo);
    } else {
      this.context.canManageTags && this.props.curationMode
        ? this.context.getPhotoId(photo, index, this.state.photos)
        : this.updatePhotoInCart(photo);
    }
  };

  handleDownloadImageSelection = ({
    photo,
    index
  }: {
    photo: any;
    index: number;
  }) => {
    this.context.getPhotoId(photo, index, this.state.photos);
  };

  printProductsflow = () => {
    return this.props.event.hasPrintProducts;
  };

  render() {
    if (this.props.loadingPhotos) {
      return (
        <div className="gss-loader album-container ">
          <img src={gssNewLoader} alt="" />
        </div>
      );
    } else {
      return (
        <div
          className={`dv-album-photos ${
            this.props.collapsibleGallery
              ? this.props.expanded
                ? "expanded"
                : "collapsed"
              : ""
          }`}
        >
          <div className="dv-album-wrap">
            {" "}
            <Gallery
              images={this.state.photos}
              key={`${this.state.photos.length}-${
                this.state.photos[0]?.id || "default"
              }`}
              rowHeight={120}
              margin={5}
              enableLightbox={false}
              enableImageSelection={false}
              onClickThumbnail={(index: number) => {
                if (this.context.eventCoverPickerMode) {
                  this.toggleEventCoverSelection(this.state.photos[index]);
                } else {
                  this.showLightBox(index);
                  ahoy.track("albumInteraction", {
                    secondary_type: "openedPhotoLightbox",
                    album_id: this.props.album.id,
                    event_id: this.props.event.id
                  });
                }
                Telemetry.track("event-gallery:opened-lightbox", {
                  eventId: this.props.event.id,
                  eventName: this.props.event.name,
                  photoId: this.props.photos[index].id,
                  embeddedMode: this.context.isEmbed
                });
              }}
              tagStyle={tagStyle}
              thumbnailImageComponent={(props: any) => {
                return (
                  <ImageComponent
                    props={props}
                    handleImageSelect={this.handleImageSelect}
                    handleDownloadImageSelection={
                      this.handleDownloadImageSelection
                    }
                    canAddToDownloadList={this.state.canAddToDownloadList}
                    primaryColor={this.context.pageConfiguration.primaryColor}
                    shouldShowCheckIcon={
                      this.state.shouldShowDownload ||
                      this.context.eventCoverPickerMode ||
                      (this.context.canManageTags && this.props.curationMode)
                    }
                    hideSelectIcon={
                      this.context.endUserDownloadsDisabled
                    }
                    event={{
                      id: this.props.event.id,
                      name: this.props.event.name,
                      price: this.props.event.price,
                      hasPrintProducts: this.props.event.hasPrintProducts
                    }}
                    addPhotoToCart={this.props.addPhotoToCart}
                    removePhotoFromCart={this.props.removePhotoFromCart}
                    printProductsflow={this.printProductsflow}
                  />
                );
              }}
              tileViewportStyle={customThumbViewportStyle}
              thumbnailStyle={customThumbStyle}
              selectedIconColor={
                this.context.pageConfiguration.primaryColor || "#34b2a7"
              }
              enableKeyboardInput={true}
              onContextMenu={this.contextMenu}
              //@ts-ignore
              selectCheckboxAlwaysVisible={Modernizr.mq(
                "only screen and (max-width: 768px)"
              )}
              onRender={this.props.galleryRowsRendered}
            />{" "}
            {this.state.showLightBox ? (
              <Modal>
                <LightBox
                  event={this.props.event}
                  album={this.props.album}
                  photos={this.state.photos}
                  photoIndex={this.state.photoIndex}
                  closeLightBox={this.closeLightBox}
                  showLightBox={this.showLightBox}
                  cartHasPhotos={this.props.cart?.photos?.length > 0}
                  showFavIcon={true}
                  addToCart={this.props.addPhotoToCart}
                  removeFromCart={this.props.removePhotoFromCart}
                  eventClickable={undefined}
                  cartId={this.props.cart?.id || null}
                  cart={this.props.cart}
                  isAuthorizedForDirectDownloads={undefined}
                  primaryColor={undefined}
                  userId={undefined}
                  isEmbed={this.context.isEmbed}
                  photoSaved={undefined}
                  curationApiCalled={this.state.curationApiCalled}
                  setCurationApiCalled={(val: boolean) =>
                    this.setState({ curationApiCalled: val })
                  }
                  trackTelemetry={true}
                  parentName={"event-gallery-lightbox"}
                  securedGalleryView={this.context?.securedGalleryView}
                  directDownloadEnabled={this.context?.directDownloadEnabled}
                  updateCartFromApiResponse={
                    this.props.updateCartFromApiResponse
                  }
                  setSelfieUploadPopup={this.props.setSelfieUploadPopup}
                  canShowEmailPopup={this.context.canShowEmailPopup}
                />
              </Modal>
            ) : null}
          </div>

          <PrecacheImg images={this.imagesToPrefetch()} />
        </div>
      );
    }
  }
}

const tagStyle = {
  display: "inline",
  padding: ".2em .6em .3em",
  fontSize: "60%",
  fontWeight: "600",
  lineHeight: "1",
  color: "#FFF",
  background: "rgba(7,36,22,.6)",
  textAlign: "center",
  whiteSpace: "nowrap",
  verticalAlign: "baseline",
  borderRadius: ".25em"
};

const customThumbViewportStyle = function (this: any) {
  return {
    width: this.props.item.vwidth,
    height: this.props.height,
    overflow: "hidden"
  };
};

const customThumbStyle = function (this: any) {
  return {
    cursor: "pointer",
    width: this.props.item.scaletwidth,
    height: this.props.height,
    marginLeft: this.props.item.marginLeft,
    marginTop: 0,
    WebkitTouchCallout: "none"
  };
};

export default Photos;
